import type { QueryResult } from '@apollo/react-hooks';
import { useQuery, gql } from '@apollo/react-hooks';
import { getAssetRelatedCounts } from '#/graphql/queries';
import type { GetAssetRelatedCountsQuery } from '#/graphql/types';

export const GET_ASSET_RELATED_COUNTS = gql(getAssetRelatedCounts);

const useAssetRelatedCounts = (assetId: string) => {
  const { data, loading }: QueryResult<GetAssetRelatedCountsQuery> = useQuery(
    GET_ASSET_RELATED_COUNTS,
    {
      variables: { assetId },
      skip: !assetId || assetId === 'new',
      fetchPolicy: 'cache-and-network',
    },
  );

  return { ...(data?.getAssetRelatedCounts ?? {}), loading };
};

export default useAssetRelatedCounts;
